import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
  progress: {
    margin: '0 auto',
    width: '100%'
  },
});

const BounceJoinFileButton = ({
  editFilename,
  classes,
  disabled,
  onExport,
}) => {
  const [ open, setOpen ] = React.useState(false);
  const [ nameEmpty, setNameEmpty ] = React.useState(true);
  const [ isLoading, setIsLoading ] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function handleNameChange(event) {
    setNameEmpty(event.target.value === '');
    editFilename(event);
  }

  function handleExport() {
    onExport();
    setIsLoading(true);
  }

  return (
    <React.Fragment>
      <Button onClick={handleClickOpen} color="primary" disabled={disabled}>
        <Icon className={classes.icon}>file_copy</Icon>
        Export to new file
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Export to new file</DialogTitle>
      <DialogContent>
        {isLoading ?
        <React.Fragment>
          <DialogContentText>
            Creating file...
          </DialogContentText>
          <LinearProgress color="secondary"/>
        </React.Fragment>
        :
        <React.Fragment>
          <DialogContentText>
          Choose a name for the new file.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            onChange={handleNameChange}
            fullWidth
          />
        </React.Fragment>
      }

      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={handleExport} color="primary" disabled={nameEmpty || isLoading}>
          Export
        </Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>
)};

BounceJoinFileButton.propTypes = {
  editFilename: PropTypes.func,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
  disabled: PropTypes.bool,
  onExport: PropTypes.func
};

export default withStyles(styles)(BounceJoinFileButton);
